import React, { useState } from 'react';
import CompanyMaintainView from './maintain-view';
import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { ISetting } from '../../../../interfaces/setting';
import { querySettings } from '../../../../adapters/setting';
import { Button } from 'antd';
import CompanyMaintainEdit from './maintain-edit';

const CompanyProfile = () => {
  const [isEdit, setIsEdit] = useState(false);
  const { data, refetch } = useQuery<AxiosResponse<ISetting>, Error>({
    queryKey: ['settings'],
    queryFn: async () => await querySettings(),
  });

  const handleClose = () => {
    setIsEdit(false);
    refetch(); // Refetch the settings data when closing the edit view
  };

  return (
    <div className="flex flex-col w-full">
      <div className="flex justify-end gap-2">
        {!isEdit && (
          <Button
            type="primary"
            size="middle"
            className=" max-w-[80px]"
            onClick={() => setIsEdit(true)}
          >
            แก้ไข
          </Button>
        )}
      </div>
      {!isEdit ? (
        <CompanyMaintainView setting={data?.data} />
      ) : (
        data?.data && (
          <CompanyMaintainEdit data={data?.data} onClose={handleClose} />
        )
      )}
    </div>
  );
};

export default CompanyProfile;
